import { XScalarStabilityValues } from "@scalar/openapi-types/schemas/extensions";
const isOperationDeprecated = (operation) => operation.deprecated || operation["x-scalar-stability"] === XScalarStabilityValues.Deprecated;
const getOperationStability = (operation) => operation.deprecated ? XScalarStabilityValues.Deprecated : operation["x-scalar-stability"];
const getOperationStabilityColor = (operation) => {
  switch (getOperationStability(operation)) {
    case XScalarStabilityValues.Deprecated:
      return "text-red";
    case XScalarStabilityValues.Experimental:
      return "text-orange";
    case XScalarStabilityValues.Stable:
      return "text-green";
    default:
      return "";
  }
};
export {
  getOperationStability,
  getOperationStabilityColor,
  isOperationDeprecated
};
//# sourceMappingURL=operation-stability.js.map
